import React, { FC } from 'react';
import { OnChangeOptionsType, TablePropsOptionsType } from 'src/types/table';
import MuiTablePagination from '@mui/material/TablePagination';
import translate from '@translate';
// import MuiPagination from '@mui/material/Pagination';
// import translate from '@translate';

type PaginationPropsType = {
    options: TablePropsOptionsType;
    onChangeOptions?: OnChangeOptionsType;
    totalCount?: number;
};
const Pagination: FC<PaginationPropsType> = (props) => {
    const handleChangePage = (event: unknown, newPage: number) => {
        if (props.onChangeOptions) {
            props.onChangeOptions({ ...props.options, page: newPage + 1 });
        }
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChangeOptions) {
            props.onChangeOptions({ ...props.options, items: Number(event.target.value), page: 1 });
        }
    };

    return (
        <MuiTablePagination
            // labelDisplayedRows={({ from, to, count }) => (
            //     <MuiPagination
            //         count={Math.ceil((props.options.totalCount || 0) / props.options.items)}
            //         page={props.options.page}
            //         onChange={handleChangepagination}
            //     />
            // )}
            // labelRowsPerPage={translate('table.rowsPerPage')}
            rowsPerPageOptions={[20, 50, 100]}
            component="div"
            count={props.totalCount || props.options.totalCount || 0}
            rowsPerPage={props.options.items}
            page={props.options.page - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={translate('table.rowsPerPage')}
        />
    );
};

export default Pagination;
